import React from 'react';

import "./HeadPane.scss";

import { ShopMenuTrigger } from '../../pages/Shop/ShopMenu/ShopMenuTrigger/ShopMenuTrigger';

import { Caption } from "@randajan/jet-react/dom/caption";
import tab from '@randajan/jet-react/base/tab';
import { Account } from '../Account/Account';

export const HeadPane = (props) => {
    const { } = props;
    const [h1] = tab.use("h1");

    const caption = h1.get("onTop") ? h1.get("content") : "";
    const longTag = caption?.length > 12 ? "tooLong" : "";

    return (
        <nav className="HeadPane">
            <section>
                <ShopMenuTrigger/>
                <Caption className={longTag}>{caption}</Caption>
                <Account/>
            </section>
        </nav>
    )
}

